<template>
  <div
    v-tooltip="tpConfig"
    :class="[
      'flex items-center cursor-pointer whitespace-nowrap px-6 pb-4 border-b-2 metric-switch justify-center',
      { 'border-primary-500 text-primary-500 font-bold': isActive },
      { 'font-light border-transparent min-w-0': !isActive }
    ]"
    @click="handleClick"
  >
    <div
      ref="textEl"
      class="text-base truncate"
    >
      {{ text }}
    </div>
  </div>
</template>

<script>
import { ref, onUnmounted, computed } from 'vue';

import useTruncate from '@/utils/useTruncate';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  setup(props, { emit }) {
    const textEl = ref(null);
    const { isTruncate, stop } = useTruncate(textEl);

    const tpConfig = computed(() => ({
      type: 'info',
      content: { text: props.text },
      preferred: ['top'],
      show: isTruncate,
    }));

    const handleClick = () => {
      emit('click', props.value);
    };

    onUnmounted(stop);

    return {
      textEl,
      tpConfig,
      handleClick,
      isTruncate,
    };
  },
};
</script>
<style lang="postcss" scoped>
.metric-switch {
  flex: 0 1 100%;
}
@screen xl {
  .metric-switch {
    flex: 0 1 auto;
  }
}
</style>
